import React from 'react'

const Input = ({ name, value, onChange, width, type, ...other }) => {
  return (
    <input
      className={`${width || 'w-full'} border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white disabled:bg-gray-50 disabled:text-gray-500`}
      id={name}
      placeholder={name}
      value={value}
      onChange={onChange}
      type={type}
      {...other}
    />
  )
}

export default Input
